<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw" epub:type="frontmatter dedication" id="Dedication1">
<div class="block-rw dedication-rw" id="dedication1">
<p class="ded-rw" id="p25"><span>For my dad, who is always there to talk hockey with me.</span></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s004-Dedication-01.vue?1be8498e